import axios from "axios"
import { env } from '../constants'


/* GET HISTORY */
export const history = (token, page = 1) => {
    const uri = `${env.startpoint}vip-three-box/history/list?page=${page}&game=UVP`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}